import React from "react";
import { Div, Row, Col, Image, Text } from "atomize";
import edward from "../../assets/images/edward.png";
import arrow_nav from "../../assets/images/arrow-nav.png";

const CustomerView = () => {
  return (
    <Div m={{ y: "6rem" }}>
      <Div
        bg="#FCB72B"
        p="4rem"
        m={{ b: "2rem" }}
        textColor="#FFFFFF"
        rounded="10px"
      >
        <Text
          textAlign="center"
          textSize={{ xs: "title", md: "display1" }}
          textWeight="700"
          m={{ b: "2rem" }}
        >
          What our customer are saying
        </Text>
        <Row align="center">
          <Col textAlign="center">
            <Image
              src={edward}
              alt="Edward Newgate"
              w="150px"
              h="150px"
              rounded="circle"
            />
            <Text textWeight="700" textSize="22px">
              Edward Newgate
            </Text>
            <Text textWeight="400" textSize="18px" m={{ b: "1rem" }}>
              Pro-Cycler
            </Text>
          </Col>
          <Col>
            <Text
              textWeight="400"
              textSize="19px"
              style={{ lineHeight: "30px" }}
            >
              Dummy Text patient engagement app and web portal allow you to
              access information instantaneously (no tedeous form, long calls,
              or administrative hassle) and securely”
            </Text>
          </Col>
        </Row>
      </Div>
      <Div d="flex" justify="space-around">
        <Image src={arrow_nav} w="400px" alt="arrow nav" cursor="pointer" />
      </Div>
    </Div>
  );
};

export default CustomerView;
